import Vue from 'vue';

export default {
  SAVE_AS_TEMPLATE: (state, response) => {
    state.saved_as_template = {
      data: response,
      status: 'success'
    };
  },
  ERROR_SAVE_AS_TEMPLATE: (state, response) => {
    state.saved_as_template = {
      data: {},
      status: 'error'
    };
  },
  SET_TEMPLATES: (state, response) => {
    response.templates.sort((a, b) => { return (a.created_at < b.created_at) ? 1 : ((b.created_at < a.created_at) ? -1 : 0); });
    for (let i = 0; i < response.length; i++) {
      response.templates[i].contract_status = response.templates[i].contract_status.charAt(0).toUpperCase() + response.templates[i].contract_status.slice(1);
      response.templates[i].contract_status = response.templates.templates[i].contract_status.split('_').join(' ');
      response.templates[i].document_type = response.templates[i].document_type.charAt(0).toUpperCase() + response.templates[i].document_type.slice(1);
      response.templates[i].document_type = response.templates[i].document_type.split('_').join(' ');
    }
    Vue.set(state, 'templates', response.templates);
    Vue.set(state, 'templates_count', response.templates_count);
  },
  SET_TEMPLATES_DROPDOWN: (state, response) => {
    response.sort((a, b) => {
      if (a.contract_name.toLowerCase() < b.contract_name.toLowerCase()) return -1;
      if (a.contract_name.toLowerCase() > b.contract_name.toLowerCase()) return 1;
      return 0;
    });
    Vue.set(state, 'templates_dropdown', response);
  },
  ERROR_DELETE_TEMPLATE: (state, response) => {
    state.deleted_template = {
      data: {},
      message: response.message,
      status: 'error'
    };
  },
  DELETE_TEMPLATE: (state, data) => {
    for (let i = 0; i < state.templates.length; i++) {
      if (state.templates[i].id == data.id) {
        state.deleted_template = {
          data: state.templates[i],
          message: data.message,
          status: 'success'
        };
        state.templates.splice(i, 1);
      }
    }
  },
  ADD_TEMPLATE: (state, response) => {
    state.templates.unshift(response.data);
    state.copied_template = {
      data: response.data,
      status: 'success'
    };
  },
  ERROR_COPY_TEMPLATE: (state, response) => {
    state.copied_template = {
      data: {},
      message: response.message,
      status: 'error'
    };
  },
};
